import type { FC } from 'react'
import { Chip, type ChipProps } from '@/components/commons/chip'
import { XCloseIcon } from '@/components/ui/icons'
import { OpsVettingFlagsContainer } from '@/features/ops-vetting/components/ops-vetting-atoms'
import {
	ServiceVettingCriteriaFlagsSelect,
	type ServiceVettingCriteriaFlagsSelectProps
} from '@/features/service-vetting/components/service-vetting-criteria-flags-select'
import type { ServiceFlag } from '@/features/service-vetting/types.ts'
import { useTranslation } from '@/translations/i18n'

interface ServiceVettingCriteriaFlagsProps
	extends Omit<ServiceVettingCriteriaFlagsSelectProps, 'selectedFlagsId'> {
	flags: ServiceFlag[]
	flagPosition?: 'left' | 'right'
	badgeVariant?: ChipProps['variant']
	hideAction?: boolean
}
export const ServiceVettingCriteriaFlags: FC<
	ServiceVettingCriteriaFlagsProps
> = ({
	flags = [],
	addFlag,
	removeFlag,
	badgeVariant = 'info',
	types,
	hideAction,
	flagPosition = 'right'
}) => {
	const { t } = useTranslation()

	return (
		<OpsVettingFlagsContainer $flagPosition={flagPosition} gap={2}>
			{!hideAction && (
				<ServiceVettingCriteriaFlagsSelect
					addFlag={addFlag}
					removeFlag={removeFlag}
					selectedFlagsId={flags.map((flag) => flag.id)}
					types={types}
				/>
			)}
			{flags.map((flag) => (
				<Chip
					endSlot={
						!hideAction && (
							<button
								onClick={() => removeFlag(flag)}
								tabIndex={-1}
								type='button'
							>
								<XCloseIcon />
							</button>
						)
					}
					isActive
					key={flag.id}
					label={t(
						`vetting:criteria.service.flags_key_name.${flag.key_name}`
					)}
					variant={badgeVariant}
				/>
			))}
		</OpsVettingFlagsContainer>
	)
}
